import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
    apiKey: "AIzaSyBhDrciUj6nOdCBykb_BGw7lZDGTUl4iGw",
    authDomain: "sampangkab-c12af.firebaseapp.com",
    projectId: "sampangkab-c12af",
    storageBucket: "sampangkab-c12af.firebasestorage.app",
    messagingSenderId: "923189867905",
    appId: "1:923189867905:web:5a6f1656ad6dc29a8fe480",
    measurementId: "G-HZE75CGXQC"
};

const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);